import React from 'react';
import { useTranslation } from "react-i18next";
import SMSA from '../../assets/images/samsa.png';
import FedEx from '../../assets/images/FedEx.png';
import DHL from '../../assets/images/DHL.png';
import AustrianPost from '../../assets/images/Austrian Post.png';
import tnt from '../../assets/images/tnt.png';
import ups from '../../assets/images/ups.png';
import ARAMEX from '../../assets/images/aramex.png';
import { getCurrencyAndLanguageSymbol } from '../../constent/currencyUtils';

const ShippingCompanies = ({ result ,selectedTo,selectedFrom ,weight}) => {
  const foundCountryData = result;
  const { t } = useTranslation();
  const currencySymbol = getCurrencyAndLanguageSymbol();
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));  
    
  if (!foundCountryData || foundCountryData.length === 0) {
    return (
      <div className="py-10 text-xl text-center text-gray-600">
        {t("noShippingCompanies")}
      </div>
    );
  }

  const getCompanyImage = (name) => {
    switch (name) {
      case "Fedex": return FedEx;
      case "AUSTRIAN POST": return AustrianPost;
      case "DHL": return DHL;
      case "SMSA": return SMSA;
      case "TNT": return tnt;
      case "UPS": return ups;
      case "ARAMEX": return ARAMEX;
      default: return null;
    }
  };

  // There is another version of this function.
  const getDeliveryTime = (name) => {
    switch (name) {
      case "FedEx":
        return `3-5 ${t("BusinessDay")}`;
      case "DHL":
        return `3-5 ${t("BusinessDay")}`;
      case "SMSA":
        return `3-5 ${t("BusinessDay")}`;
      case "AUSTRIAN POST":
        return `8-12 ${t("BusinessDay")}`;
      default:
        return `3-5 ${t("BusinessDay")}`;
    }
  };

  const commonWeight = weight ?? t("notAvailable");
  return (
    <div className="py-4 overflow-x-auto">
      <table className="min-w-full text-center border border-gray-200">
        <thead className="bg-custom-yellow">
          <tr>
            <th className="px-2 py-2 text-xs border md:px-4 md:py-3 md:text-base">{t("shippingWeight")}</th>
            <th className="px-2 py-2 text-xs border md:px-4 md:py-3 md:text-base">{t("company")}</th>
            <th className="px-2 py-2 text-xs border md:px-4 md:py-3 md:text-base">{t("deliveryTime")}</th>
            <th className="px-2 py-2 text-xs border md:px-4 md:py-3 md:text-base">{t("ShippingCostFrom")} {t(`${selectedFrom}`)} {t("to")} {t(`countries.${selectedTo}`)}</th>
          </tr>
        </thead>
        <tbody>
          {foundCountryData.map((company, index) => (
            <tr key={index} className="">
              {index === 0 && (
                <td className="px-2 py-2 text-xs font-semibold border md:px-4 md:py-3 md:text-base" rowSpan={foundCountryData.length}>
                  {commonWeight} {t("kg")}
                </td>
              )}
              
              <td className="px-2 py-2 text-xs border md:px-4 md:py-3 md:text-base">
                <img
                  src={getCompanyImage(company.companyName)}
                  alt={company?.companyName}
                  className={` mx-auto ${company.companyName==="UPS" ? "w-12": "w-24"}`}
                />
              </td>
              <td className="px-2 py-2 text-xs border md:px-4 md:py-3 md:text-base" dir='rtl'>{getDeliveryTime(company.companyName)}</td>
              <td className="px-2 py-2 font-bold border md:px-4 md:py-3">
                {roundToTwo(Number(company?.countryData?.cost))}
                <span className="text-[9px] text-black"> {currencySymbol}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShippingCompanies;
